import {
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Flex,
  Portal,
  useMediaQuery,
} from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import type { PublicEventStep, WizardStep } from "../wizardSteps";
import { WizardNavigation } from "./WizardNavigation";

interface Props {
  steps: ReadonlyArray<WizardStep>;
  currentStep: PublicEventStep;
  navigateToStep: (step: PublicEventStep) => void;
}

export const MobileStepDrawer = ({ steps, currentStep, navigateToStep }: Props) => {
  const [showDrawer, setShowDrawer] = useState(false);
  const [isLargerThan768] = useMediaQuery("(min-width: 768px)");
  const { t } = useTranslation();

  const closeAndNavigate = (step: PublicEventStep) => {
    setShowDrawer(false);
    navigateToStep(step);
  };

  if (isLargerThan768) return null;

  return (
    <>
      <Drawer placement="bottom" onClose={() => setShowDrawer(false)} isOpen={showDrawer}>
        <DrawerOverlay />
        <DrawerContent borderTop="1px solid" borderColor="smBorder">
          <DrawerBody py="4">
            <WizardNavigation
              steps={steps}
              currentStep={currentStep}
              navigateToStep={closeAndNavigate}
            />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
      <Portal>
        <Flex
          position="fixed"
          zIndex={20}
          bottom="0"
          left="0"
          right="0"
          height="60px"
          borderTop="1px solid"
          borderColor="smBorder"
          alignItems="center"
          bg="smBackground"
          px="3"
        >
          <Button variant="solid" colorScheme="teal" width="full" onClick={() => setShowDrawer(true)}>
            {t("Change step")}
          </Button>
        </Flex>
      </Portal>
    </>
  );
};
